import { createReduxModule } from "hooks-for-redux";
import { StatusCodes } from "http-status-codes";
import {
  IApplicationContextResponse,
  IApplicationDefinition,
  ICountry,
  ICustomerProfile,
  IMembershipApplication,
  IMembershipHistory,
  IMembershipProductPrices,
  IProduction,
  IProductPrices,
  IStepZeroValidation,
} from "../../registration/utils/types/applicationContextTypes";
import getApplicationContext from "../../registration/api/get/getApplicationContext";

const initialState: IApplicationContextResponse = {
  personId: 0,
  membershipApplicationId: 0,
  statusId: 0,
  status: "",
  hasEthicsComplaint: false,
  failsDisabilityCondition: false,
  failsAssociationCondition: false,
  applicationIsBlocked: false,
  stepZeroValidation: {} as IStepZeroValidation,
  stepZeroMessage: "",
  message: "",
  Message: "",
  applicationDefinition: {} as IApplicationDefinition,
  customerProfile: {} as ICustomerProfile,
  membershipHistory: {} as IMembershipHistory,
  country: {} as ICountry,
  membershipApplication: {} as IMembershipApplication,
  membershipProductPrices: {} as IMembershipProductPrices,
  productPrices: {} as IProductPrices,
  production: [] as IProduction[],
  companyProduction: [] as IProduction[],
  waiverValue: "",
};

export const [
  useAppContext,
  { setAppContext, UpdateLateFee, UpdateMembershipYears },
  appContextStore,
] = createReduxModule("appContext", initialState, {
  setAppContext: (state, data: IApplicationContextResponse) => ({
    ...state,
    ...data,
  }),
  UpdateLateFee: (state, lateFeeValue: number) => ({
    ...state,
    productPrices: {
      ...state.productPrices,
      lateFees: lateFeeValue,
    },
  }),
  UpdateMembershipYears: (state, newOverallYears: number) => ({
    ...state,
    membershipHistory: {
      ...state.membershipHistory,
      totalYears: {
        ...state.membershipHistory.totalYears,
        memberhsip: {
          ...state.membershipHistory.totalYears.memberhsip,
          overall: newOverallYears,
        },
      },
    },
  }),
});

export const updateAppContext = async (personId: number, jwt: string) => {
  const res = await getApplicationContext(personId, jwt);

  if (
    res?.status !== StatusCodes.OK &&
    res?.status !== StatusCodes.BAD_REQUEST &&
    res?.status !== StatusCodes.UNPROCESSABLE_ENTITY
  )
    return res?.status;
  setAppContext(res.data);

  return StatusCodes.OK;
};
